import React from 'react'
import { func } from 'prop-types'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'

import * as spacing from 'styles/spacing'
import { white } from 'styles/colors'
import { media } from 'styles/media'
import { H1, H2, fontSizes } from 'styles/typography'
import { Action } from 'components/home/FeaturedProduct'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
`

const ActionWrap = styled.div`
  position: absolute;
  top: ${spacing.xLarge};
  right: ${spacing.xLarge};
  z-index: 10;

  ${media.large`
    top: ${spacing.xxLarge};
    right: ${spacing.xxLarge};
  `};

  ${media.xLarge`
    top: ${spacing.xxxLarge};
    right: ${spacing.xxxLarge};
  `};
`

const Panel = styled.div`
  height: 100%;
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

const Heading = styled(H1)`
  color: ${white};
  font-family: 'Trim Poster';
  display: block;
  margin-bottom: 0.2em;

  ${media.small`
    font-size: 54px;
  `};

  ${media.medium`
    font-size: 60px;
  `};

  ${media.large`
    font-size: 66px;
  `};

  ${media.xLarge`
    font-size: 72px;
  `};
`

const Content = styled.div`
  width: 100%;
  padding: ${spacing.xLarge};
  padding-top: 0;
  margin-top: ${spacing.medium};

  ${media.xLarge`
    padding: ${spacing.xxxLarge};
    padding-top: 0;
  `};
`

const EngravingPanel = styled(Panel)`
  background-color: #6c6c6c;
  background-image: url('${process.env.BASE_PATH}/images/home/offers/engraving-bg.jpg');
  padding-right: 20%;
`

const SkinsPanel = styled(Panel)`
  background-color: #6c3452;
  background-image: url('${process.env.BASE_PATH}/images/home/offers/skins-bg.jpg');
  text-align: right;
  margin-left: -25%;
  clip-path: polygon(40% 0, 100% 0, 100% 100%, 0% 100%);
  padding-left: 20%;
`

const Details = styled.div`
  display: flex;
  align-items: center;

  ${SkinsPanel} & {
    flex-direction: row-reverse;
  }
`

const Price = styled(H2)`
  color: ${white};
  display: block;
`

const PriceWrap = styled.div`
  position: static;

  ${EngravingPanel} & {
    margin-right: ${spacing.large};

    ${media.large`
      margin-right: ${spacing.xLarge};
    `};
  }

  ${SkinsPanel} & {
    margin-left: ${spacing.large};

    ${media.large`
      margin-left: ${spacing.xLarge};
    `};
  }
`

const Meta = styled.span`
  color: ${white};
  font-size: ${fontSizes.small};
  display: block;
`

const DeviceWrap = styled.div`
  align-self: center;
  width: 84px;

  ${media.large`
    width: 94px;
  `};

  ${media.xLarge`
    width: 102px;
  `};

  ${media.xxLarge`
    width: 5vw;
    min-width: 120px;
    max-width: 140px;
  `};
`

const Device = styled.img`
  width: 100%;
`

const CustomizeEpod = ({ handleCtaClick }) => (
  <Container className="u-hide-medium-down">
    <ActionWrap>
      <Action label="DISCOVER ePod" onClick={handleCtaClick} />
    </ActionWrap>
    <EngravingPanel>
      <DeviceWrap>
        <LazyLoad>
          <Device src={`${process.env.BASE_PATH}/images/home/offers/engraving-device.png`} alt="Engraved device" />
        </LazyLoad>
      </DeviceWrap>
      <Content>
        <Heading as="span">
          ePod
          <br />
          ENGRAVING
        </Heading>
        <Details>
          <PriceWrap>
            <Price as="span">$14.99*</Price>
            <Meta>Device included</Meta>
          </PriceWrap>

          <Button to="/buy-online/engravable" theme="custom" customColor={white} variant="outline" size="large">
            Buy now
          </Button>
        </Details>
      </Content>
    </EngravingPanel>
    <SkinsPanel>
      <DeviceWrap>
        <LazyLoad>
          <Device src={`${process.env.BASE_PATH}/images/home/offers/skins-device.png`} alt="Custom skin" />
        </LazyLoad>
      </DeviceWrap>
      <Content>
        <Heading as="span">
          ePod
          <br />
          SKINS
        </Heading>
        <Details>
          <PriceWrap>
            <Price as="span">$3.99</Price>
          </PriceWrap>

          <Button to="/buy-online/vype-epod-skins" theme="custom" customColor={white} variant="outline" size="large">
            Buy now
          </Button>
        </Details>
      </Content>
    </SkinsPanel>
  </Container>
)

CustomizeEpod.propTypes = {
  handleCtaClick: func.isRequired
}

export default CustomizeEpod
